import CentralPedidosView from "../views/pedidos/CentralPedidosView.vue";
import NovoPedidoView from "../views/pedidos/NovoPedidoView";
import SelecionarTipoPedidoView from "../views/pedidos/SelecionarTipoPedidoView";
import NovoPedidoInsumosView from "../views/pedidos/NovoPedidoInsumosView";
//import SelecionarProdutosInsumosView from "../views/pedidos/mobile/SelecionarProdutosInsumosView";
//import AdicionarProdutoView from "../views/pedidos/mobile/AdicionarProdutoView";
import insumosStore from "@/store/insumos";
import pedidosStore from "@/store/pedidos";
//import PedidoFinalizadoView from "../views/pedidos/mobile/PedidoFinalizadoView.vue";
import CentralPedidosInsumosView from "../views/pedidos/CentralPedidosInsumosView.vue";

export default [
  {
    path: "/central-pedidos",
    name: "central de pedidos",
    component: CentralPedidosView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
  {
    path: "/central-pedidos-insumos",
    name: "central de pedidos insumos/veterinária",
    component: CentralPedidosInsumosView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
  {
    path: "/novo-pedido",
    name: "Novo pedido",
    component: NovoPedidoView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: false,
    },
  },
  {
    path: "/selecionar-tipo-pedido/:tipo",
    name: "Selecionar Tipo Pedido",
    component: SelecionarTipoPedidoView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: false,
    },
  },
  {
    path: "/novo-pedido-insumos",
    name: "Novo pedido insumos/veterinaria",
    component: NovoPedidoInsumosView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: false,
    },
    beforeEnter: async (to, from, next) => {
      pedidosStore.mutations.resetState(pedidosStore.state);
      insumosStore.mutations.resetState(insumosStore.state);
      insumosStore.mutations.setPedidoItemStorage(insumosStore.state);
      //await insumosStore.mutations.setProdutosDisponiveisStorage();

      if (insumosStore.state.pedido_item.cliente != null) {
        pedidosStore.state.novopedido.cliente =
          insumosStore.state.pedido_item.cliente;
      }
      next();
    },
  },
  /*{
    path: "/novo-pedido-insumos/selecionar-produtos",
    name: "Selecionar produtos insumos/veterinaria",
    component: SelecionarProdutosInsumosView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: false,
      device: [1],
    },
    beforeEnter: async (to, from, next) => {
      insumosStore.mutations.setPedidoItemStorage(insumosStore.state);
      if (insumosStore.state.produtosDisponiveis.length == 0) {
        await insumosStore.mutations.setProdutosDisponiveisStorage(
          insumosStore.state
        );
      }
      next();
    },
  },
  {
    path: "/novo-pedido-insumos/selecionar-produtos/:id",
    name: "Adicionar Produto",
    component: AdicionarProdutoView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: false,
      device: [1],
    },
    beforeEnter: async (to, from, next) => {
      insumosStore.mutations.setPedidoItemStorage(insumosStore.state);
      if (insumosStore.state.produtosDisponiveis.length == 0) {
        await insumosStore.mutations.setProdutosDisponiveisStorage(
          insumosStore.state
        );
      }
      next();
    },
  },
  {
    path: "/novo-pedido-insumos/finalizado/:id",
    name: "Pedido finalizado",
    component: PedidoFinalizadoView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: false,
      device: [1],
    },
  },*/
];
